import { useState, useEffect } from 'react';
import PermissionService from '../services/PermissionService';

export const usePermissions = () => {
  const [permissions, setPermissions] = useState({
    prediction: true,
    timeline: true,
    timesheet: true,
    subtargets: true,
    chatbot: true,
    zoho: false,
    odoo: false,
    phrm: false,
    gem: true,
    planApproval: true,
    targetApproval: true,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true);
      try {
        const userPermissions = await PermissionService.getUserPermissions();
        setPermissions(userPermissions);
      } catch (error) {
        console.error('Error fetching permissions:', error);
        // Keep default permissions on error
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();

    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('permissionsUpdated', handlePermissionUpdate);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('permissionsUpdated', handlePermissionUpdate);
      }
    };
  }, []);

  const hasPermission = (featureName) => {
    return permissions[featureName] !== false;
  };

  const refreshPermissions = async () => {
    setLoading(true);
    try {
      const userPermissions = await PermissionService.refreshPermissions();
      setPermissions(userPermissions);
    } catch (error) {
      console.error('Error refreshing permissions:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    permissions,
    loading,
    hasPermission,
    refreshPermissions,
    hasPredictionPermission: hasPermission('prediction'),
    hasTimelinePermission: hasPermission('timeline'),
    hasTimesheetPermission: hasPermission('timesheet'),
    hasSubtargetsPermission: hasPermission('subtargets'),
    hasChatbotPermission: hasPermission('chatbot'),
    hasZohoPermission: hasPermission('zoho'),
    hasOdooPermission: hasPermission('odoo'),
    hasGemPermission: hasPermission('gem'),
    hasPhrmPermission: hasPermission('phrm'),
    hasPlanApprovalPermission: hasPermission('planApproval'),
    hasTargetApprovalPermission: hasPermission('targetApproval'),
  };
};
